import { IFetchCounterValue } from "@types"
import { protectedApi } from "../../Api/protectedAPI"

const actionsFetchCounterValues = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        actionsFetchCounterValues: builder.query<IFetchCounterValue[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `actions/fetch_counter_values`,
                }
            },
        }),
    }),
})

export const { useActionsFetchCounterValuesQuery } = actionsFetchCounterValues
